document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelectorAll('.at-test').length > 0) {
    let tot_vata = 0, tot_pitta = 0, tot_kapha = 0;

    // Helper function to update results
    function updateResults(tot_vata, tot_pitta, tot_kapha) {
      const atResults = document.querySelector('.at-total');
      const atResultsContainer = document.querySelector('.at-results');

      if (tot_vata > 0 || tot_pitta > 0 || tot_kapha > 0) {
        atResults.querySelector('.tot-vata').textContent = tot_vata;
        atResults.querySelector('.tot-pitta').textContent = tot_pitta;
        atResults.querySelector('.tot-kapha').textContent = tot_kapha;
        atResultsContainer.style.display = 'block';

        // Determine which result to show
        const totMax = Math.max(tot_vata, tot_pitta, tot_kapha);
        document.querySelector('.at-results-vata').style.display = totMax === tot_vata ? 'block' : 'none';
        document.querySelector('.at-results-pitta').style.display = totMax === tot_pitta ? 'block' : 'none';
        document.querySelector('.at-results-kapha').style.display = totMax === tot_kapha ? 'block' : 'none';
      } else {
        atResultsContainer.style.display = 'none';
      }
    }

    // Add click event listeners for Vata
    document.querySelectorAll('.at-test td.vata').forEach(function (cell) {
      cell.addEventListener('click', function () {
        if (cell.classList.contains('at-selected')) {
          cell.classList.remove('at-selected');
          tot_vata--;
        } else {
          cell.classList.add('at-selected');
          tot_vata++;
        }
        updateResults(tot_vata, tot_pitta, tot_kapha);
      });
    });

    // Add click event listeners for Pitta
    document.querySelectorAll('.at-test td.pitta').forEach(function (cell) {
      cell.addEventListener('click', function () {
        if (cell.classList.contains('at-selected')) {
          cell.classList.remove('at-selected');
          tot_pitta--;
        } else {
          cell.classList.add('at-selected');
          tot_pitta++;
        }
        updateResults(tot_vata, tot_pitta, tot_kapha);
      });
    });

    // Add click event listeners for Kapha
    document.querySelectorAll('.at-test td.kapha').forEach(function (cell) {
      cell.addEventListener('click', function () {
        if (cell.classList.contains('at-selected')) {
          cell.classList.remove('at-selected');
          tot_kapha--;
        } else {
          cell.classList.add('at-selected');
          tot_kapha++;
        }
        updateResults(tot_vata, tot_pitta, tot_kapha);
      });
    });
  }
});
